<template>
  <div class="renewPrice">
    <div class="renewPrice__header">
      套餐类型：
      <el-select
        v-model="params.simType"
        placeholder="请选择"
        size="small"
        style="width:165px;margin:0 20px 0 0"
      >
        <el-option
          v-for="item in typeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        style="margin-left:10px"
        type="primary"
        size="small"
        @click="getData"
      >查询</el-button>
      <el-button
        style="margin-left:auto"
        type="primary"
        size="small"
        @click="$refs.setPriceRef.visible = true;"
      >修改续费单价</el-button>
    </div>
    <div class="renewPrice__content">
      <div class="filter-table-wrap">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          size="mini"
          border
          height="calc(100% - 90px)">
          <el-table-column
            type="index"
            width="50"
            label="序号"
          >
          </el-table-column>
          <el-table-column
            prop="userCode"
            align="center"
            label="客户代码"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="type"
            align="center"
            label="订单号"
            v-slot="{row}"
          >
            <span>
              {{row.type == 1?'续费':'叠加包'}}
            </span>
          </el-table-column>
          <el-table-column
            width="150"
            prop="simType"
            align="center"
            label="套餐类型"
            v-slot="{row}"
          >
            <span>
              {{row.simType}}M
            </span>
          </el-table-column>
          <el-table-column
            width="50"
            prop="counts"
            align="center"
            label="数量"
          >
          </el-table-column>
          <el-table-column
            width="150"
            prop="price"
            align="center"
            label="总金额"
          >
          </el-table-column>
          <el-table-column
            width="150"
            prop="createTime"
            align="center"
            label="卡商"
            v-slot="{row}"
          >
            <span v-if="row.cardSupplier != null">{{useCardSupplier(row.cardSupplier)}} </span>
          </el-table-column>
          <el-table-column
            width="180"
            prop="createTime"
            align="center"
            label="创建时间"
          >
          </el-table-column>
          <el-table-column
            width="200"
            prop="updateTime"
            align="center"
            label="修改时间"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            width="200"
            label="订单日期"
          >
          </el-table-column>
          <el-table-column
            width="150"
            label="状态"
            prop="orderStatus"
          />
        </el-table>
        <el-pagination
          :current-page.sync="params.pageNumber"
          :page-sizes="[100, 200, 300, 400]"
          :page-size.sync="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <set-price ref="setPriceRef" @getData="getData" :simType="params.simType" />
  </div>
</template>
<script>
import SetPrice from "./setPrice";
export default {
  components:{
    SetPrice
  },
  data(){
    return {
      tableData:[],
      params:{
        simType:'30M',
        pageNumber:1,
        pageSize:100
      },
      total:0,
      typeList:[
        {
          value:'30M',
          lable:30
        },
        {
          value:'100M',
          lable:100
        },
      ]
    }
  },
  created(){
    this.getData();
  },
  methods:{
    useCardSupplier(type){
      return {
        1:'北京移动',
        2:'江门移动',
        3:'重庆卡',
        4:'江西卡',
        5:'深圳卡',
        6:'谷米卡',
        7:'北京移动(新)',
        8:'北京移动(新)',
        9:'北京移动(新)',
        10:'北京移动语音卡',
        11:'深圳移动',
        12:'联通',
        13:'北京移动4G卡',
        14:'惠州联通',
        15:'陕西移动',
        16:'云杉卡',
        17:'齐犇卡',
        18:'北京单4G卡',
      }[type];
    },
    //查询数据
    async getData(){
      let { pageNumber,pageSize } = this.params
      const { data } = await this.$API.getSimRenewPriceList({
        simType:parseInt(this.params.simType),
        pageNumber,
        pageSize
      });
      this.tableData = data.data;
      this.total = data.total;
    },
  }
}
</script>
<style lang="scss" scoped>
.renewPrice{
  width: 100%;
  height:100%;
  padding: 10px 0;
  box-sizing: border-box;
  &__header {
    width: 100%;
    display: flex;
    padding: 10px 20px;
    background: #ffffff;
    height: 84px;
    align-items: center;
    font-size: 14px;
    box-sizing: border-box;
    .filter-type-input {
      background: #edf2f8;
      color: #828588;
      border: none;
      outline: 0;
      padding: 0 15px;
      height: 30px;
    }
    /deep/ .el-date-editor {
      width: 15%;
      .el-input__inner {
        padding-left: 30px;
        height: 30px;
        border-radius: 0;
        outline: none;
        border: 0;
        background: #f3f7fb;
      }
      .el-input__icon {
        line-height: 30px;
      }
    }
  }
  &__content {
    flex: 1;
    background: #fff;
    height: calc(100% - 84px);
    padding-top: 10px;
    padding:0 10px;
    .btn_cursor{
      color:#409EFF;
      display: inline-block;
      padding: 0 10px;
      cursor: pointer;
    }
    .filter-table-wrap {
      border: 1px solid #ebf0f6;
      height: 100%;
      /deep/ .el-pagination {
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        & > span {
          margin: 0;
        }
        .el-pagination__total {
          margin-right: auto;
        }
      }
    }
  }
}
</style>